<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetLoginSettings'
});

interface FormSettings
{
    settings: any;
}

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $t } = useLocalization();

const module = ref('account');
const articleModule = ref('articles');
const defaults = ref<any>({
    page: null,
    privacyPolicyPage: null,
    cookiesPage: null,
    adminContactPage: null
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            page: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Strona z modułu konto użytkownika]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <EditoPageSelector
            v-model="form.settings.page"
            :module="module"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>

    <hr>

    <IdeoFormGroup :label="$t('[[[Strona docelowa dla \'Polityka prywatności\']]]')" :invalid-feedback="form.$errors.first('settings.privacyPolicyPage')" :state="form.$errors.state('settings.privacyPolicyPage')">
        <EditoPageSelector
            v-model="form.settings.privacyPolicyPage"
            :module="articleModule"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Strona docelowa dla \'Pliki cookies\']]]')" :invalid-feedback="form.$errors.first('settings.cookiesPage')" :state="form.$errors.state('settings.cookiesPage')">
        <EditoPageSelector
            v-model="form.settings.cookiesPage"
            :module="articleModule"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Strona docelowa dla \'Kontakt z adminem\']]]')" :invalid-feedback="form.$errors.first('settings.adminContactPage')" :state="form.$errors.state('settings.adminContactPage')">
        <EditoPageSelector
            v-model="form.settings.adminContactPage"
            :module="articleModule"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>
</template>
